




























































































import { Component, Vue } from 'vue-property-decorator'
import { CompanyAPI, DashboardAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'
import { cloneDeep, isEqual } from 'lodash'
import { Dashboard } from '@/api/model/dashboard'
import { v4 as uuid } from 'uuid'
import LicenseTypeIframe from '@/components/ui/LicenseTypeIframe.vue'
import { escapeHtml } from '@/helpers/html'

@Component({
    components: { LicenseTypeIframe },
})
export default class CompanySettingsReports extends Vue {
    company: Company = null
    dashboards: Dashboard[] = []
    loading: boolean = false
    newReport: string = ''
    newReportId: string = ''
    adding: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.company = cloneDeep<Company>(this.$currentCompany)
        this.dashboards = await DashboardAPI.getAll()
        this.loading = false
    }

    async save(): Promise<void> {
        try {
            this.loading = true
            this.$root.$currentCompany = await CompanyAPI.update(this.company.id, this.company)
            await this.reload()
        } finally {
            this.loading = false
        }
    }

    async add(): Promise<void> {
        try {
            this.adding = true
            await DashboardAPI.create(Dashboard.fromData({
                company: this.$currentCompany,
                id: uuid(),
                title: this.newReport,
                text: '',
                sort: 999,
                component: 'power-bi-report',
                powerBiId: this.newReportId,
            }))
            await this.reload()
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.adding = false
        }
    }

    get hasChanges(): boolean {
        return isEqual(this.$currentCompany, this.company) === false
    }

    get customDashboards(): Dashboard[] {
        return this.dashboards.filter(dashboard => dashboard.company !== null)
    }
}
